/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { adminControllerCreate } from '../fn/admin/admin-controller-create';
import { AdminControllerCreate$Params } from '../fn/admin/admin-controller-create';
import { adminControllerDelete } from '../fn/admin/admin-controller-delete';
import { AdminControllerDelete$Params } from '../fn/admin/admin-controller-delete';
import { adminControllerFindById } from '../fn/admin/admin-controller-find-by-id';
import { AdminControllerFindById$Params } from '../fn/admin/admin-controller-find-by-id';
import { adminControllerLogout } from '../fn/admin/admin-controller-logout';
import { AdminControllerLogout$Params } from '../fn/admin/admin-controller-logout';
import { adminControllerLogUnmask } from '../fn/admin/admin-controller-log-unmask';
import { AdminControllerLogUnmask$Params } from '../fn/admin/admin-controller-log-unmask';
import { adminControllerMe } from '../fn/admin/admin-controller-me';
import { AdminControllerMe$Params } from '../fn/admin/admin-controller-me';
import { adminControllerRefresh } from '../fn/admin/admin-controller-refresh';
import { AdminControllerRefresh$Params } from '../fn/admin/admin-controller-refresh';
import { adminControllerSearchOffset } from '../fn/admin/admin-controller-search-offset';
import { AdminControllerSearchOffset$Params } from '../fn/admin/admin-controller-search-offset';
import { adminControllerSignIn } from '../fn/admin/admin-controller-sign-in';
import { AdminControllerSignIn$Params } from '../fn/admin/admin-controller-sign-in';
import { adminControllerToggleBlock } from '../fn/admin/admin-controller-toggle-block';
import { AdminControllerToggleBlock$Params } from '../fn/admin/admin-controller-toggle-block';
import { adminControllerUpdate } from '../fn/admin/admin-controller-update';
import { AdminControllerUpdate$Params } from '../fn/admin/admin-controller-update';
import { AdminDto } from '../models/admin-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class AdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `adminControllerSearchOffset()` */
  static readonly AdminControllerSearchOffsetPath = '/api/admin/search/offset';

  /**
   * 관리자 오프셋 기반 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerSearchOffset$Response(params: AdminControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return adminControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 오프셋 기반 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerSearchOffset(params: AdminControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.adminControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `adminControllerMe()` */
  static readonly AdminControllerMePath = '/api/admin/me';

  /**
   * 내 정보.
   *
   * 내 정보를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerMe()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerMe$Response(params?: AdminControllerMe$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDto>> {
    return adminControllerMe(this.http, this.rootUrl, params, context);
  }

  /**
   * 내 정보.
   *
   * 내 정보를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerMe$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerMe(params?: AdminControllerMe$Params, context?: HttpContext): Observable<AdminDto> {
    return this.adminControllerMe$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdminDto>): AdminDto => r.body)
    );
  }

  /** Path part for operation `adminControllerFindById()` */
  static readonly AdminControllerFindByIdPath = '/api/admin/{id}';

  /**
   * 관리자 조회.
   *
   * 관리자를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerFindById$Response(params: AdminControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<AdminDto>> {
    return adminControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 조회.
   *
   * 관리자를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerFindById(params: AdminControllerFindById$Params, context?: HttpContext): Observable<AdminDto> {
    return this.adminControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdminDto>): AdminDto => r.body)
    );
  }

  /** Path part for operation `adminControllerDelete()` */
  static readonly AdminControllerDeletePath = '/api/admin/{id}';

  /**
   * 관리자 삭제.
   *
   * 관리자를 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerDelete$Response(params: AdminControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return adminControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 삭제.
   *
   * 관리자를 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerDelete(params: AdminControllerDelete$Params, context?: HttpContext): Observable<boolean> {
    return this.adminControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `adminControllerUpdate()` */
  static readonly AdminControllerUpdatePath = '/api/admin/{id}';

  /**
   * 관리자 수정.
   *
   * 관리자 정보를 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerUpdate$Response(params: AdminControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return adminControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 수정.
   *
   * 관리자 정보를 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerUpdate(params: AdminControllerUpdate$Params, context?: HttpContext): Observable<boolean> {
    return this.adminControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `adminControllerSignIn()` */
  static readonly AdminControllerSignInPath = '/api/admin/signin';

  /**
   * 관리자 로그인.
   *
   * 관리자 로그인을 수행합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerSignIn()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerSignIn$Response(params: AdminControllerSignIn$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'accessToken'?: string;
'refreshToken'?: string;
}>> {
    return adminControllerSignIn(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 로그인.
   *
   * 관리자 로그인을 수행합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerSignIn$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerSignIn(params: AdminControllerSignIn$Params, context?: HttpContext): Observable<{
'accessToken'?: string;
'refreshToken'?: string;
}> {
    return this.adminControllerSignIn$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'accessToken'?: string;
'refreshToken'?: string;
}>): {
'accessToken'?: string;
'refreshToken'?: string;
} => r.body)
    );
  }

  /** Path part for operation `adminControllerCreate()` */
  static readonly AdminControllerCreatePath = '/api/admin/create';

  /**
   * 관리자 생성.
   *
   * 관리자를 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerCreate$Response(params: AdminControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return adminControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 생성.
   *
   * 관리자를 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerCreate(params: AdminControllerCreate$Params, context?: HttpContext): Observable<boolean> {
    return this.adminControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `adminControllerRefresh()` */
  static readonly AdminControllerRefreshPath = '/api/admin/refresh';

  /**
   * 관리자 토큰 갱신.
   *
   * 관리자 토큰을 갱신합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerRefresh()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerRefresh$Response(params?: AdminControllerRefresh$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'accessToken'?: string;
}>> {
    return adminControllerRefresh(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 토큰 갱신.
   *
   * 관리자 토큰을 갱신합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerRefresh$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerRefresh(params?: AdminControllerRefresh$Params, context?: HttpContext): Observable<{
'accessToken'?: string;
}> {
    return this.adminControllerRefresh$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'accessToken'?: string;
}>): {
'accessToken'?: string;
} => r.body)
    );
  }

  /** Path part for operation `adminControllerLogout()` */
  static readonly AdminControllerLogoutPath = '/api/admin/signout';

  /**
   * 로그아웃.
   *
   * 로그아웃합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerLogout()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerLogout$Response(params?: AdminControllerLogout$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return adminControllerLogout(this.http, this.rootUrl, params, context);
  }

  /**
   * 로그아웃.
   *
   * 로그아웃합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerLogout$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerLogout(params?: AdminControllerLogout$Params, context?: HttpContext): Observable<boolean> {
    return this.adminControllerLogout$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `adminControllerToggleBlock()` */
  static readonly AdminControllerToggleBlockPath = '/api/admin/block-toggle/{id}';

  /**
   * 관리자 차단 | 차단해제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerToggleBlock()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerToggleBlock$Response(params: AdminControllerToggleBlock$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return adminControllerToggleBlock(this.http, this.rootUrl, params, context);
  }

  /**
   * 관리자 차단 | 차단해제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerToggleBlock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminControllerToggleBlock(params: AdminControllerToggleBlock$Params, context?: HttpContext): Observable<boolean> {
    return this.adminControllerToggleBlock$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `adminControllerLogUnmask()` */
  static readonly AdminControllerLogUnmaskPath = '/api/admin/log/unmask';

  /**
   * 마스킹 해제 로그 기록.
   *
   * 관리자가 마스킹을 해제할 때 로그를 기록합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminControllerLogUnmask()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerLogUnmask$Response(params: AdminControllerLogUnmask$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return adminControllerLogUnmask(this.http, this.rootUrl, params, context);
  }

  /**
   * 마스킹 해제 로그 기록.
   *
   * 관리자가 마스킹을 해제할 때 로그를 기록합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminControllerLogUnmask$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminControllerLogUnmask(params: AdminControllerLogUnmask$Params, context?: HttpContext): Observable<boolean> {
    return this.adminControllerLogUnmask$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
